import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Cross, Conditional } from '@cashfree-intl/coherent';

import { ACTIVE, REJECTED, DISABLED } from '../constants';
import { StyledBanner } from '../styles';

const OnDemandStatusBanner = ({ onClose, status }) => (
  <>
    <Conditional if={status === ACTIVE}>
      <StyledBanner>
        <Alert size="md" type="success" compact bordered>
          Congratulations, Your On-Demand Settlements withdrawal limit has been
          increased.
          <Cross
            size="md"
            className="ml-3"
            onClick={onClose}
            data-event-name="Icon_Close"
          />
        </Alert>
      </StyledBanner>
    </Conditional>
    <Conditional if={[REJECTED, DISABLED].includes(status)}>
      <StyledBanner>
        <Alert size="md" type="danger" compact bordered>
          On-Demand Settlements has been disabled. Contact care@cashfree.com for
          further help.
          <Cross
            size="md"
            className="ml-3"
            onClick={onClose}
            data-event-name="Icon_Close"
          />
        </Alert>
      </StyledBanner>
    </Conditional>
  </>
);

OnDemandStatusBanner.propTypes = {
  onClose: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
};

export default OnDemandStatusBanner;
